var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "attachment-filter-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('grid', {
    staticClass: "uk-dropdown-grid uk-grid-divider",
    attrs: {
      "size": "medium"
    }
  }, [_c('div', {
    staticClass: "uk-width-1-2"
  }, [_c('ul', {
    staticClass: "uk-nav uk-dropdown-nav"
  }, [_c('li', {
    staticClass: "uk-nav-header"
  }, [_vm._v(_vm._s(_vm.$t('headers.type')))]), _vm._v(" "), _c('li', [_c('radio-group-input', {
    attrs: {
      "collection": _vm.availableTypeFilters,
      "inline": false,
      "label": undefined,
      "include-blank": _vm.$t('filters.undefined')
    },
    model: {
      value: (_vm.form.model.type),
      callback: function($$v) {
        _vm.form.model.type = $$v
      },
      expression: "form.model.type"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-2"
  }, [_c('ul', {
    staticClass: "uk-nav uk-dropdown-nav"
  }, [_c('li', {
    staticClass: "uk-nav-header"
  }, [_vm._v(_vm._s(_vm.$t('headers.contentType')))]), _vm._v(" "), _c('li', [_c('radio-group-input', {
    attrs: {
      "collection": _vm.availableContentTypeFilters,
      "inline": false,
      "label": undefined,
      "include-blank": _vm.$t('filters.undefined')
    },
    model: {
      value: (_vm.form.model.contentType),
      callback: function($$v) {
        _vm.form.model.contentType = $$v
      },
      expression: "form.model.contentType"
    }
  })], 1)])])]), _vm._v(" "), _c('grid', {
    staticClass: "uk-dropdown-grid",
    attrs: {
      "size": "medium"
    }
  }, [_c('div', {
    staticClass: "uk-width-1-2"
  }, [_c('submit-button', {
    staticClass: "uk-width-1-1",
    attrs: {
      "type": "primary",
      "icon": "check",
      "text": _vm.$t('actions.apply')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-2"
  }, [_c('common-button', {
    staticClass: "uk-width-1-1",
    attrs: {
      "icon": "close",
      "text": _vm.$t('actions.reset')
    },
    on: {
      "click": _vm.reset
    }
  })], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66dbe9da","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/AttachmentFilterForm.vue
// module id = 2027
// module chunks = 0